import React from 'react';

import ContentWithSidebar from './ContentWithSidebar';
import UploadCommissionPayment from './UploadCommissionPayment';

const DEFAULT_ITEM = 'upload-commission-payment';

const items = [
  {
    slug: 'upload-commission-payment',
    title: 'Upload Commission Payment',
    component: UploadCommissionPayment,
  },
];

export default function AgentHubPage() {
  return <ContentWithSidebar items={items} defaultItem={DEFAULT_ITEM} />;
}
